/**
 * Table classes that pin the first column while a wide table scrolls sideways,
 * so a row keeps its name. The pinned cells need an opaque background: pair
 * this with a `[&_td:first-child]:bg-*` that matches the table's surface.
 */
export const STICKY_FIRST_COL =
  '[&_th:first-child]:sticky [&_th:first-child]:left-0 [&_th:first-child]:z-10 [&_th:first-child]:bg-gray-900 ' +
  '[&_td:first-child]:sticky [&_td:first-child]:left-0 [&_td:first-child]:z-10';
